
import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../../theme";

import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import { WarehouseInvoiceCard } from "../../../../../components/global/cards/financial/InvoiceCard";
import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";
import ShTextSkeleton from "../../../../../components/theme/skeleton/ShTextSkeleton";
import { useGetAllRelationInvoiceProductsQuery } from "../../../../../newapi/global/relation/relationSlice";
import { formatPrice } from "../../../../../utils/helpers";

import ShDataGrid2 from "../../../../../components/theme/datagrid2/ShDataGrid2";
import SidepanelLoader from "../../../../../components/theme/sidepanel2/SidepanelLoader";
import ShDataGrid3 from "../../../../../components/theme/datagrid3/ShDataGrid3";

const GridActions = (props) => {
    const theme = useTheme();
    return (
        <Box display="flex" alignItems="center" justifyContent="space-between" flex={1} gap={2}>
            <ButtonGroup version={2}>
            </ButtonGroup>
        </Box>
    )
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,

};

const InvoiceProducts = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isExtended, setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();
    
    const ref = useRef();
    const [config, setConfig] = useState({
        id: 0
    });

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
        });

        return () => {
        }
    },[]);

    const columns = [
        {
            field: "name", 
            headerName: t('name'),
            flex:2, 
            cellClassName: "sku-cell", 
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return params.row.invoiceProduct.name
            }
        },
        {
            field: "price", 
            headerName: t('price'),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                if (params.row.isCustomPrice) {
                    return formatPrice(i18n, params.row.price)
                } else {
                    return formatPrice(i18n, params.row.categoryProduct?.price)
                }
            }
        },
        {
            field: "priceIncrease", 
            headerName: t('active_price_increase'),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                if (params.row.invoiceProduct?.priceIncreases?.length > 0) {
                    const percentage = parseFloat(params.row.invoiceProduct.priceIncreases[0].percentage);
                    let date = params.row.invoiceProduct.priceIncreases[0].date ? 
                    new Date(params.row.invoiceProduct.priceIncreases[0].date).toLocaleDateString(i18n.language) : "-";
                    const price = params.row.isCustomPrice ? parseFloat(params.row.price) : parseFloat(params.row.categoryProduct?.price);

                    if (price && percentage) {
                        return `${formatPrice(i18n, parseFloat((100 + percentage) / 100 * price))} ${t("_per")} ${date}`;
                    }
                }
                return "";
            }
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return <></>
            }
        },
    ];

    return (
        <Box height={1} ref={ref} display={"flex"} flexDirection={"column"}>
            {/* <GridActions></GridActions> */}
            <ShDataGrid3 
                key={theme.palette.mode}
                gridKey="relations.financial.rates"
                content={useGetAllRelationInvoiceProductsQuery}
                config={config}
                // gridActions={<GridActions></GridActions>} 
                title={t('all')}
                gridOptions={gridOptions} 
                sortModel={{field: columns[0].field,type:"DESC"}}
                columns={columns}
                >
            </ShDataGrid3>
        </Box>
    );
}

export default InvoiceProducts;